/**
 * specifies whether or not this is a development build.
 */
declare const __DEV__: boolean;
import "libConfig/bluebird";
import "libConfig/knockout";
import "bindingHandlers";
import "moment-timezone";
import Bluebird from "bluebird";
import ko from "knockout";
import $ from "jquery";
import { buildRouteDefinitions, createRouter } from "router";
import App from "viewModels/App";
import localeService from "services/localeService";
import embeddingService from "services/embeddingService";
import authService from "services/authService";
import featureToggleService, {
    FeatureToggle,
} from "services/featureToggleService";
import { Client } from "@genesys/cloud-frontend/client";
import { BaseAPI } from "@genesys/cloud-frontend/api-base";
import config from "config";
import moment from "moment";
import toastService from "services/toastService";
import { genesysApp } from "util/genesysAppHeader";
import audioUtils from "util/audioUtils";
import { registerSparkComponents } from "genesys-spark";
import cssFeatureToggleService from "services/cssFeatureToggleService";
import loggingService from "services/loggingService";

BaseAPI.setGenesysAppHeader(genesysApp);

if (__DEV__) {
    import("devTools");
}

const app = new App();
const applyBindings = ko.applyBindings.bind(ko, app, document.body);

app.activateLoadingView();
applyBindings();

const router = createRouter(buildRouteDefinitions(app), () => {
    app.activateNotFoundView();
});

Bluebird.all([
    authService.init(),
    // todo ts-ify app configuration
    Client.getClient((config as any).appName),
])
    .then(() =>
        Bluebird.all([
            embeddingService
                .getEnvData()
                .then((response) => {
                    const envData = response.envData;
                    const timeZoneId = envData?.custom?.timeZone?.id;

                    if (timeZoneId && moment.tz.zone(timeZoneId)) {
                        ko.i18n.setTimezone(timeZoneId);
                    } else if (timeZoneId) {
                        // If the timezone is defined, but not valid
                        loggingService.error(
                            "Received an Invalid or Unsupported timezoneId:",
                            timeZoneId
                        );
                        toastService.notifyMajorAlert("timezone.error");
                    }
                    return localeService.loadLocale(envData.locale);
                })
                .then((loadedLocale) => {
                    return localeService.setLocale(loadedLocale);
                }),

            featureToggleService.init().then((result) => {
                cssFeatureToggleService.init();
                if (result[FeatureToggle.WEM_1418_IDUI_SPARK_V4_FLARE]) {
                    registerSparkComponents();
                } else {
                    registerSparkComponents({ theme: "legacy" });
                }

                if (result[FeatureToggle.REC_7506_CHECK_FOR_OGG_SUPPORT_FT]) {
                    return audioUtils.init();
                }
            }),
        ])
    )
    .then(() => {
        localeService.onLocaleChanged.subscribe(() => {
            ko.cleanNode($("body.frameless")[0]);
            applyBindings();
        });

        // run our routes
        router.init();

        // Initialize New Relic actionText override to prevent PII capture
        // This should run after DOM is ready and New Relic is loaded
        app.initNewRelicActionTextOverride();

        // notify parent frame that we have started running routes
        embeddingService.notifyInitialized();
    });
